import {
  getAllDesktopElementsByList,
  getAllMobileElementsByList
} from 'crazyEditor/redux/modules/element/elementSelectors';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FontIcon from 'material-ui/FontIcon';
import MenuItem from 'shared/components/MenuItem';
import Divider from 'material-ui/Divider';
import connectWithRouter from 'shared/components/redux/connectWithRouter';
import globalControlStyles from '../GlobalControlsStyles';
import styles from './SaveButtonStyles';
import { closeStaticPanel, openLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import { MENU_PANELS } from 'crazyEditor/core/constants/panelConstants';
import CustomSvgIconNew from 'crazyEditor/components/EditorUI/BaseUI/CustomSvgIcon/CustomSvgIconNew';
import {codeBraces, rename, duplicate, saveAll, save, publish, fileOutline} from 'shared/icons/index';
import IconMenu from 'material-ui/IconMenu';
import FlatButton from 'material-ui/FlatButton';
import {PopoverAnimationVertical} from 'material-ui/Popover';
import { TYPES, EDITOR_PANELS } from 'crazyEditor/core/constants/panelConstants';
import {TEMPLATE_NAME_DIALOG_TYPE} from 'crazyEditor/components/TemplateNameDialog/TemplateNameDialog';
import {makeACopy} from 'shared/helpers/copyTemplateHelper';
import {getActionButtonProps, getActionMenuItemProps} from 'MyAccount/Listings/consts';

@connectWithRouter(
  (state) => {
    return ({
      allDesktopElements: getAllDesktopElementsByList(state),
      allMobileElements: getAllMobileElementsByList(state),
      bulkReviseEnabled: state.user.bulkReviseEnabled,
      isTemplate: _.isEmpty(state.listingData),
      ebayConnected: !_.isEmpty(state.accountPage.accounts),
    });
  }, {closeStaticPanel, openLazyPanel}
)
export default class SaveButtonDropDownPanel extends Component {
  static contextTypes = {
    integrationConnector: PropTypes.object,
  };

  handleRenameClicked = () => {
    const {openLazyPanel} = this.props;
    openLazyPanel(EDITOR_PANELS.TEMPLATE_NAME, TYPES.EDITOR_PANEL, null, {type: TEMPLATE_NAME_DIALOG_TYPE.RENAME});
  };

  render() {
    const {ebayConnected, isTemplate, bulkReviseEnabled, primaryAction, onClickSave, onPrimaryActionClick, openPublishDialog} = this.props;
    const integrationEnabled = this.context.integrationConnector.isIntegrationEnabled();
    return (
      <IconMenu
        iconButtonElement={<FlatButton {...(!isTemplate ? styles.primaryButtonProperties : {})} style={globalControlStyles.buttonStyle}><FontIcon style={_.assign({}, globalControlStyles.iconButtonStyle, styles.iconButtonStyle)} className="material-icons">arrow_drop_down</FontIcon></FlatButton>}
        anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
        targetOrigin={{horizontal: 'left', vertical: 'top'}}
        animation={PopoverAnimationVertical}
      >
        <MenuItem style={globalControlStyles.menuItemStyle}
                  onClick={onPrimaryActionClick}
                  {...getActionMenuItemProps(primaryAction)}
        />
        {
          !isTemplate &&
          <MenuItem style={globalControlStyles.menuItemStyle}
                    onClick={() => onClickSave()}
                    {...getActionMenuItemProps('saveAsTemplate')}
          />
        }
        {
          !integrationEnabled && isTemplate && bulkReviseEnabled &&
          <MenuItem style={globalControlStyles.menuItemStyle}
                    tooltip={<div><div>SAVE & APPLY ALL</div><div style={{lineHeight: '130%', paddingBottom: 10}}>Save template and update all listings that use this template.</div></div>}
                    onClick={() => onClickSave({andApplyAll: true})}
                    primaryText="Save & Apply All"
                    leftIcon={<CustomSvgIconNew path={saveAll}/>}
          />
        }
        {
          integrationEnabled &&
          <MenuItem style={globalControlStyles.menuItemStyle}
                    onClick={() => onClickSave({andExit: true})}
                    primaryText="Save and Exit"
                    leftIcon={<CustomSvgIconNew path={save}/>}
          />
        }
        {
          !integrationEnabled && isTemplate &&
            [
              <Divider key="0"/>,
              <MenuItem key="1" style={globalControlStyles.menuItemStyle}
                        tooltip={<div><div>MAKE A COPY</div><div style={{lineHeight: '130%', paddingBottom: 10}}>Create new template with this design and open it in a new tab.</div></div>}
                        onClick={() => {makeACopy(this.props);}}
                        primaryText="Make a Copy"
                        leftIcon={<CustomSvgIconNew path={duplicate}/>}
              />,
              <MenuItem key="2" style={globalControlStyles.menuItemStyle}
                        tooltip={<div><div>RENAME</div><div style={{lineHeight: '130%', paddingBottom: 10}}>Rename this template.</div></div>}
                        primaryText="Rename"
                        onClick={this.handleRenameClicked}
                        leftIcon={<CustomSvgIconNew path={rename}/>}
              />
            ]
        }
        {
          ebayConnected && (!bulkReviseEnabled || !isTemplate) ?
          <MenuItem style={globalControlStyles.menuItemStyle}
                    onClick={openPublishDialog}
                    {...getActionMenuItemProps('showHtml')}
          /> : undefined
        }
      </IconMenu>
    );
  }
}